import Firefly from 'firefly-sdk-ts'
import { eventManagerConfig } from './fireflyConfig'

const globalData = {
  application: {
    name: 'Seller landing UI',
  },
}

export const initializeFirefly = () => {
  // Needed for session id used by analytics correlation.
  Firefly.registerEventManagerWithConfig(eventManagerConfig)
  Firefly.setGlobalDataLayer(globalData, eventManagerConfig.persistMethod)
}
